import { StackProps, Stack, styled } from "@mui/material";
import FreshdiLoading from "Components/loading/FreshdiLoading";
import { Main } from "Components/Main";
import { ReactNode, Suspense, lazy, useState, useMemo, useRef, Fragment } from "react";
import { useSelector, useDispatch } from "react-redux";
import { getOpenChat } from "redux/selectors/chat";
import { closeOpenChat } from "redux/actions/chat";
import { SmCloseIcon } from "Assets/icons";
import { PATHS } from "constants/routes";
import useBreakpoints from "hooks/useBreakpoint";
import useUser from "hooks/useUser";
import { isValidPlan } from "helpers/plan";
import MainLoading from "Components/loading/MainLoading";

const Header = lazy(() => import("Components/header/Header"));
const Footer = lazy(() => import("Components/Footer"));
const FloatingActionBar = lazy(() => import("Components/bar/FloatingActionBar"));
const MessagesForGuest = lazy(() => import("Pages/ai-agent/components/MessagesForGuest"));
const Page = lazy(() => import("Pages/ai-agent"));

type Props = {
  children?: ReactNode;
  mainprops?: StackProps;
  hideSearch?: boolean;
  isWorkSpace?: boolean;
  isHomePage?: boolean;
};

const LoadingLayout = () => {
  return (
    <>
      <Header />
      <Main>
        <MainLoading />
      </Main>
      <FloatingActionBar />
      <Footer />
    </>
  );
};

const Layout = (props: Props) => {
  const { children, hideSearch, isWorkSpace, isHomePage } = props;
  const isOpenChat = useSelector(getOpenChat);
  const [colorTouch, setColorTouch] = useState('#ccc')
  const { isMobile } = useBreakpoints();
  const { isLoggedIn, user } = useUser();
  const [isUseTrail, setIsUseTrail] = useState(false)
  const userStatus = useSelector(
    (state: any) => state?.userReducer?.userStatus
  );
  const isFreePlan = useMemo(
    () => !isValidPlan(user?.supplier?.plan) && userStatus === "fulfilled",
    [user, userStatus]
  );

  const dispatch = useDispatch();

  const [height, setHeight] = useState(window.innerHeight / 1.15);
  const touchStartRef = useRef(0);
  const heightRef = useRef(height);

  const handleTouchStart = (e: React.TouchEvent<HTMLDivElement>) => {
    touchStartRef.current = e.touches[0].clientY;
    heightRef.current = height;
    setColorTouch('black')
  };
  const handleTouchEnd = () => {
    setColorTouch('#ccc')
  };

  const handleTouchMove = (e: React.TouchEvent<HTMLDivElement>) => {
    const touchY = e.touches[0].clientY;
    const deltaY = touchY - touchStartRef.current;
    const maxHeight = window.innerHeight;
    const newHeight = heightRef.current - deltaY * 0.9;

    requestAnimationFrame(() => {
      setHeight(Math.max(100, Math.min(maxHeight, newHeight)));
    });
  };

  return (
    <Fragment>
      {!isOpenChat ? (
        // <Fragment>
        //   <Suspense fallback={<FreshdiLoading />}>
        //     <Header {...{ hideSearch, isWorkSpace, isHomePage }} />
        //   </Suspense>

        //   <Main {...props.mainprops}>
        //     <Suspense fallback={<FreshdiLoading />}>{children}</Suspense>
        //   </Main>
        //   <Suspense fallback={<FreshdiLoading />}>
        //     <FloatingActionBar />
        //   </Suspense>
        //   <Suspense fallback={<FreshdiLoading />}>
        //     <Footer />
        //   </Suspense>
        // </Fragment>
        <Suspense fallback={<LoadingLayout />}>
          <>
            <Header {...{ hideSearch, isWorkSpace, isHomePage }} />
            <Main {...props.mainprops}>{children}</Main>
            <FloatingActionBar />
            <Footer />
          </>
        </Suspense>
      ) :
        (
          <Suspense fallback={<FreshdiLoading />}>
            <StyledMainHaveChat >
              <div className="left-main-home">
                <Suspense fallback={<FreshdiLoading />}>
                  <Header {...{ hideSearch, isWorkSpace, isHomePage }} />
                </Suspense>

                <Main {...props.mainprops}>
                  <Suspense fallback={<FreshdiLoading />}>{children}</Suspense>
                </Main>
                <Suspense fallback={<FreshdiLoading />}>
                  <FloatingActionBar />
                </Suspense>
                <Suspense fallback={<FreshdiLoading />}>
                  <Footer />
                </Suspense>
              </div>
              <Stack className="messenger-box" style={{ height: isMobile ? height : '100vh', display: isMobile ? 'none' : '' }}>
                <div
                  className="chat-dragger"
                  onTouchStart={handleTouchStart}
                  onTouchMove={handleTouchMove}
                  onTouchEnd={handleTouchEnd}
                  style={{ backgroundColor: colorTouch }}
                />
                <div className="root-aigent">
                  <div className="left-aigent">
                    <img src={'/images/common/ai_agent_unActive.svg'} alt="img" loading="lazy" className="chat-img" />
                    <span className="text-name-ai">Vivian AI Agent</span>
                  </div>
                  <div className="right-aigent">
                    <img src={'/images/common/Icon_openWindow.svg'} alt="img" loading="lazy" className="chat-img-openWindow"
                      onClick={() => window.open(PATHS.aiAgent, '_blank')}
                    />
                    <SmCloseIcon className="close" color="#667085" onClick={() => { dispatch(closeOpenChat(false)); setHeight(window.innerHeight / 1.15) }} />
                  </div>
                </div>
                {
                  isLoggedIn ? (
                    <Fragment>
                      {isFreePlan && !isUseTrail
                        ? (<MessagesForGuest setIsUseTrail={setIsUseTrail} isTrail />)
                        : (<Page isOpenShareScreen={true} />)
                      }
                    </Fragment>
                  ) : (
                    <MessagesForGuest />
                  )
                }
              </Stack>
            </StyledMainHaveChat >
          </Suspense>
        )
      }
    </Fragment>
  )
};

const StyledMainHaveChat = styled(Stack)(({ theme }) => ({
  backgroundColor: "var(--bg-color)",
  padding: "8px 0",
  display: "flex",
  flexDirection: "row",
  flex: 1,
  maxWidth: '100%',
  overflow: 'hidden',
  height: '100vh',
  position: 'fixed',
  "& .left-main-home": {
    flex: 0.75,
    maxWidth: '75%',
    overflow: 'auto',
    maxHeight: '100vh'
  },
  "& .messenger-box": {
    flex: 0.25,
    maxWidth: "25%",
    overflow: "hidden",
    maxHeight: "100vh",
    backgroundColor: "#fff",
    borderRadius: 8,
    position: 'relative',
    padding: '16px'
  },
  "& .chat-img": {
    width: '17px',
    height: '14px',
  },
  "& .root-aigent": {
    display: "flex",
    flexDirection: "row",
    justifyContent: 'space-between',
    alignItems: 'center',
    position: 'absolution',
    zIndex: 99,
    background: "white",
    width: "-webkit-fill-available",
    // padding: '0px 16px 0px 16px',
  },
  "& .left-aigent": {
    display: "flex",
    flexDirection: "row",
    alignItems: 'center',
    gap: '8px',
    marginBottom: '8px'
  },
  "& .right-aigent": {
    gap: '8px',
    display: "flex",
    flexDirection: "row",
  },
  "& .chat-img-openWindow": {
    height: 15,
    width: 15,
    cursor: 'pointer'
  },
  "& .close": {
    cursor: 'pointer',
    color: '#667085',
  },
  "& .text-name-ai": {
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '18px',
    color: '#008934'
  },

  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    "& .left-main-home": {
      flex: 1,
      maxWidth: '100%',
      overflow: 'auto',
      maxHeight: '100%'
    },
    "& .messenger-box": {
      maxWidth: "100%",
      height: "auto",
      zIndex: '99',
      bottom: '0px',
      position: "fixed",
      width: '100%',
      left: '50%',
      transform: 'translateX(-50%)',
      background: 'white',
      boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.1)',
      overflow: 'hidden',
      transition: "height 0.2s ease-out",
      padding: "16px 0px 0px 0px",
    },
    ".MuiContainer-root": {
      paddingLeft: 8,
      paddingRight: 8,
      flex: 1,
      maxWidth: '100%',
      maxHeight: '100%'
    },
    ".title": {
      fontSize: 16,
    },
    ".chat-dragger": {
      width: '20%',
      height: '10px',
      cursor: 'ns-resize',
      touchAction: 'none',
      maxHeight: '10px',
      minHeight: '10px',
      transition: "height 0.2s ease-out",
      alignSelf: 'center',
      borderRadius: '12px'
    }
  },
}));

export default Layout;
